import { render, staticRenderFns } from "./CompactWorkerCost.vue?vue&type=template&id=2ad74ae0&scoped=true&"
import script from "./CompactWorkerCost.vue?vue&type=script&lang=js&"
export * from "./CompactWorkerCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad74ae0",
  null
  
)

export default component.exports